var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9V4H10V7L8 5V4H7C6.45 4 6 3.55 6 3C6 2.45 6.45 2 7 2H17C17.55 2 18 2.45 18 3C18 3.55 17.55 4 17 4H16V9C16 10.66 17.34 12 19 12V14H15.985L14 12H15C14.37 11.16 14 10.12 14 9Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9C10 10.1 9.65 11.14 9 12H10.5L12.97 14.5V21L11.97 22L10.97 21V14H5V12C6.66 12 8 10.66 8 9H10Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06055 4L18.9999 18.9393",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpin);
export default __webpack_public_path__ + "static/media/unpin.bd7178975d5936c4858efbb20496f7f3.svg";
export { ForwardRef as ReactComponent };